import Store from '@/store/computed/storeHelpers'

export default {
  data() {
    return {
      allPossibleHeaders: [
        {
          text: "ID",
          align: "left",
          value: "id"
        },
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        {
          text: "Belongs To",
          align: "left",
          value: "belongsTo",
          type: "text"
        },
        {
          text: "Type",
          align: "left",
          value: "typeDisp"
        },
        {
          text: "MasterFile",
          align: "left",
          value: "modelDisp",
          type: "text"
        },
        {
          text: "Email",
          align: "left",
          value: "contactEmail",
          type: "text"
        },
        {
          text: "Expiry Date",
          align: "left",
          value: "dateDisp",
          type: "text"
        },
        {
          text: "Notes",
          align: "left",
          value: "notes",
          type: "text"
        },
        {
          text: "Created At",
          align: "right",
          value: "createdAt",
          type: "date"
        },
        {
          text: "Updated At",
          align: "left",
          value: "updatedAt",
          type: "date"
        },
      ]
    }
  },
  methods: {
    filterHeaders() {
      return this.allPossibleHeaders.filter(header => {
        if (header.value == "actions") { return true }
        return !!this.defaultHeaders.filter(field => {
          return header.value == field
        }).length
      })
    }
  },
  computed: {
    defaultHeaders: Store.getSet({ store: 'shared', prop: 'complianceDefaultHeaders' }),
    headers() {
      var tempArray = this.filterHeaders()
      var actions = {
        text: "Actions",
        align: "center",
        value: "",
        sortable: false,
        type: "action"
      }
      tempArray.push(actions)
      return tempArray
    }
  },
}